// src/components/Button.js
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

const buttonBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.75rem;
  border-radius: 9999px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 0.9375rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  border: none;
  transition: background-color 0.2s ease, color 0.2s ease, transform 0.15s ease;

  &:hover {
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

// Primary — terracotta fill (default)
const Button = styled(Link)`
  ${buttonBase}
  background-color: #a0412d;
  color: #fff7f6;

  &:hover {
    background-color: #913523;
    color: #fff7f6;
    transform: translateY(-1px);
  }
`;

// Secondary — teal variant
export const ButtonSecondary = styled(Link)`
  ${buttonBase}
  background-color: #84f5e8;
  color: #005c55;

  &:hover {
    background-color: #75e7da;
    color: #004842;
    transform: translateY(-1px);
  }
`;

// Ghost — outline style for lighter contexts
export const ButtonGhost = styled(Link)`
  ${buttonBase}
  background-color: transparent;
  color: #a0412d;
  box-shadow: inset 0 0 0 1.5px #a0412d;

  &:hover {
    background-color: #ffac9b;
    color: #721f0f;
    transform: translateY(-1px);
  }
`;

// Native button element variant (for forms)
export const ButtonNative = styled.button`
  ${buttonBase}
  background-color: #a0412d;
  color: #fff7f6;
  width: auto;

  &:hover {
    background-color: #913523;
    color: #fff7f6;
    transform: translateY(-1px);
  }
`;

export default Button;
